import axios, { type AxiosResponse } from "axios";
import { jwtToken } from "../utils/token";
import { logMessage } from "../../utils/amplifyLogger";

type HttpMethod = "GET" | "POST" | "PUT" | "DELETE" | "PATCH";

export interface GatewayParams {
  endpoint?: string;
  params?: Record<string, unknown>;
  pathTemplate: string;
  method: HttpMethod;
  queryParams?: Record<string, unknown>;
  body?: Record<string, unknown> | unknown[] | string | object;
}

export const awsClientGateway = async ({
  endpoint,
  params = {},
  pathTemplate,
  method,
  queryParams = {},
  body = {},
}: GatewayParams): Promise<AxiosResponse> => {
  try {
    const tokenData = await jwtToken();
    if (!tokenData) {
      throw new Error("Failed to retrieve JWT token");
    }
    const { headers } = tokenData;

    const config = {
      baseURL: endpoint ?? process.env.REACT_APP_BACKEND_API_ENDPOINT,
      url: pathTemplate,
      headers,
      params: { ...params, ...queryParams },
      method,
      data: Array.isArray(body)
        ? body
        : typeof body === "object"
          ? { ...body }
          : body,
      timeout: 0,
    };

    const response = await axios(config);
    if (!response) {
      throw new Error(`Http error in ApiGateway Request! status: ${response}`);
    }
    return response;
  } catch (err) {
    logMessage(
      `Gateway`,
      `Something went wrong in ApiGateway Request : ${err}`,
      `error`,
    );
    throw err;
  }
};
